export const BUILD_VERSION = 'v2-final-arabic';
